export function languages() {
  return [
    { title: "ru", value: "ru" },
    { title: "kz", value: "kz" },
    { title: "mx", value: "mx" },
  ];
}

export function timeNormalizer(timeInSeconds) {
  if (timeInSeconds == null || isNaN(timeInSeconds) || timeInSeconds < 0) {
    return "00:00:00";
  }

  const units = [
    { label: "мес", seconds: 30 * 24 * 3600 },
    { label: "дн", seconds: 24 * 3600 },
    { label: "ч", seconds: 3600 },
    { label: "мин", seconds: 60 },
    { label: "с", seconds: 1 },
  ];

  let remaining = timeInSeconds;
  const parts = [];

  for (const { label, seconds } of units) {
    const value = Math.floor(remaining / seconds);
    if (value > 0 || label === "ч" || label === "мин" || label === "с") {
      remaining %= seconds;
      if (label === "ч" || label === "мин" || label === "с") {
        parts.push(String(value).padStart(2, "0"));
      } else {
        parts.push(`${value} ${label}`);
      }
    }
  }

  const timeIndex = parts.findIndex((p) => /^\d{2}$/.test(p));
  if (timeIndex !== -1) {
    const timeParts = parts.splice(timeIndex);
    parts.push(timeParts.join(":"));
  }

  return parts.join(" ").trim();
}

export function timeShortHuman(seconds) {
  if (seconds == null || isNaN(seconds) || seconds < 0) return "";

  const oneMinute = 60;
  const oneHour = 3600;
  const oneDay = 86400;

  function plural(value, one, few, many) {
    const v = Math.abs(value);
    const mod10 = v % 10;
    const mod100 = v % 100;
    if (mod10 === 1 && mod100 !== 11) return one;
    if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return few;
    return many;
  }

  if (seconds < oneMinute) {
    const s = +seconds.toFixed(2);
    const sClean = String(s).replace(/\.0$/, "");
    return `${sClean} ${plural(sClean, "секунда", "секунды", "секунд")}`;
  }

  if (seconds < oneHour) {
    const m = +(seconds / oneMinute).toFixed(2);
    return `${m} ${plural(m, "минута", "минуты", "минут")}`;
  }

  if (seconds < oneDay) {
    const h = +(seconds / oneHour).toFixed(2);
    return `${h} ${plural(h, "час", "часа", "часов")}`;
  }

  const d = +(seconds / oneDay).toFixed(2);
  return `${d} ${plural(d, "день", "дня", "дней")}`;
}
